import React from 'react';
import { Empty } from 'antd';
import {
  TableRow,
  EmptyRow,
  TableCell,
} from '../../../../../../components/customTableComponents';

const NoDataRow = ({ columnCount }) => {
  return (
    <>
      <EmptyRow />
      <TableRow>
        <TableCell colSpan={columnCount} transparent>
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </TableCell>
      </TableRow>
    </>
  );
};

export default NoDataRow;
